import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import H1 from '../Images/Hma.jpeg';
import L1 from '../Images/logo-w.png';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = (e) => {
        e.preventDefault();
        const correctEmail = 'admin.hma@gmail.com';
        const correctPassword = 'admin.hma';
        if (email === correctEmail && password === correctPassword) {
            navigate('/dashboard-Dashboard/34g-54fg-fgrr/dashboard');
        } else {
            setError('Invalid email or password');
        }
    };

    return (
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
       
            <div>
                <img src={H1} alt="Header Image" style={{ width: '100%', height: '200px', objectFit: 'cover' }} />
            </div>
  
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
                <div style={{
                    backgroundColor: 'white',
                    padding: '30px',
                    borderRadius: '10px',
                    boxShadow: '0px 15px 30px rgba(0, 0, 0, 0.1)',
                    width: '100%',
                    maxWidth: '400px',
                    border: '1px solid #e2e2e2',
                    marginTop: '-70px', 
                }}>
                    <h3 style={{ textAlign: 'center', color: '#333' }}>Login</h3>
                    <form onSubmit={handleLogin}>
                        <div style={{ marginBottom: '20px' }}>
                            <label htmlFor="email" style={{ display: 'block', fontSize: '14px', color: '#555' }}>Email Address</label>
                            <input
                                type="email"
                                id="email"
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '8px',
                                    border: '1px solid #ccc',
                                    fontSize: '16px',
                                    transition: 'border-color 0.3s',
                                }}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="Enter your email"
                            />
                        </div>

                        <div style={{ marginBottom: '20px' }}>
                            <label htmlFor="password" style={{ display: 'block', fontSize: '14px', color: '#555' }}>Password</label>
                            <input
                                type="password"
                                id="password"
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '8px',
                                    border: '1px solid #ccc',
                                    fontSize: '16px',
                                    transition: 'border-color 0.3s',
                                }}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="Enter your password"
                            />
                        </div>

                        {error && (
                            <div style={{
                                color: 'red',
                                fontSize: '14px',
                                marginBottom: '15px',
                                padding: '10px',
                                backgroundColor: '#f8d7da',
                                borderRadius: '5px',
                            }}>
                                {error}
                            </div>
                        )}

                        <button type="submit" style={{
                            width: '100%',
                            padding: '10px',
                            backgroundColor: '#4d88d6',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '16px',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s',
                        }} onMouseOver={(e) => e.target.style.backgroundColor = '#3a74a0'} onMouseOut={(e) => e.target.style.backgroundColor = '#4d88d6'}>
                            Login
                        </button>
                    </form>
                </div>
            </div>

            {/* Footer */}
            <footer style={{
                backgroundColor: '#f1f1f1',
                padding: '20px 0',
                textAlign: 'center',
                marginTop: 'auto',
            }}>
                <div>
                    <p style={{ margin: '0', fontSize: '14px', color: '#777' }}>
                        Powered by
                        <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer" style={{
                            color: '#4CAF50',
                            textDecoration: 'none',
                            marginLeft: '5px',
                        }}>
                            EMedha Technologies
                        </a>
                    </p>
                    <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer">
                        <img src={L1} alt="EMedha Logo" style={{
                            width: '150px',
                            height: 'auto',
                            marginTop: '10px',
                        }} />
                    </a>
                </div>
            </footer>
        </div>
    );
};

export default Login;
